<template>
    <div id="falafel" class="direction-ltr">
        <div class="content-section-a" id="sections-one" ref="falafel">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8 order-lg-last">
                        <div :class="{'direction-rtl': language === 'he'}">
                            <h2 class="section-heading text-center">{{ $t('פיתוח זה לא פלאפל') }}</h2>
                            <div data-aos="fade-up" data-aos-duration="1200">
                                <p class="lead">{{ $t('אתם לא צריכים להיות מומחים כדי להבין שקצב ההתקדמות של העולם הטכנולוגי פשוט לא דומה לשום דבר אחר.') }}</p>
                                <p class="lead">{{ $t('אז פעם הבא שיספרו לכם בגאון ') }}<strong>{{ $t('"מפתחים אתרים כבר 30 שנה"') }}</strong>{{ $t(' - תרימו גבה! כי היום מפתחים אתרים ואפליקציות אחרת, ולכן מתכנת שלא משקיע לילות כימים בלמידת הטכנולוגיות החדשות ביותר - פשוט הופך ללא רלוונטי.') }}</p>
                                <p class="lead">{{ $t('אז פלאפל תמשיכו לאכול אצל') }} <strong>{{ $t('"פלאפל ברכה - אותו מתכון כבר 30 שנה"') }}</strong>{{ $t(', אבל לפיתוח האתר שלכם אתם פשוט חייבים צוות צעיר, מקצועי וחדשני!') }}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 order-lg-first" data-aos="fade-up" data-aos-duration="1200">
                        <div class="smoke-container">
                            <svg width="80px" height="73px" viewBox="0 0 31 73">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g class="smokes" transform="translate(2.000000, 2.000000)" stroke="#BEBEBE" stroke-width="5">
                                        <g class="smoke-1">
                                            <path id="Shape1" d="M0.5,8.8817842e-16 C0.5,8.8817842e-16 3.5,5.875 3.5,11.75 C3.5,17.625 0.5,17.625 0.5,23.5 C0.5,29.375 3.5,29.375 3.5,35.25 C3.5,41.125 0.5,41.125 0.5,47"></path>
                                        </g>
                                        <g class="smoke-2">
                                            <path id="Shape2" d="M0.5,8.8817842e-16 C0.5,8.8817842e-16 3.5,5.875 3.5,11.75 C3.5,17.625 0.5,17.625 0.5,23.5 C0.5,29.375 3.5,29.375 3.5,35.25 C3.5,41.125 0.5,41.125 0.5,47"></path>
                                        </g>
                                        <g class="smoke-3">
                                            <path id="Shape3" d="M0.5,8.8817842e-16 C0.5,8.8817842e-16 3.5,5.875 3.5,11.75 C3.5,17.625 0.5,17.625 0.5,23.5 C0.5,29.375 3.5,29.375 3.5,35.25 C3.5,41.125 0.5,41.125 0.5,47"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <img class="img-responsive mx-auto my-auto d-block" src="img/falafel/falafel.png" alt="productive labs about image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data (){
            return{
                mobile: window.matchMedia("(max-width:767px)").matches,
            }
        },
        name: 'falafel',
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
        },
    }
</script>

<style lang="css" scoped>
    #sections {
           color: #fff;
       }
    .content-section-a {
        padding: 50px 0;
        background-color: #fff;
    }
    .section-heading {
        margin-bottom: 30px;
    }

    .smoke-container {
        display: flex;
        position: relative;
        width: 100px;
        margin: 0 auto;
        position: relative;
    }
    .smoke-1 {
        animation: shift 5s linear 0.5s infinite;
        opacity: 0;
    }
    .smoke-2 {
        animation: shift-2 4s linear 0.6s infinite;
        opacity: 0;
    }
    .smoke-3 {
        animation: shift-3 5s linear 1.2s infinite;
        opacity: 0;
    }

    .smokes {
        transform: translateX(20px);
    }
    @-moz-keyframes shift {
        0% {
            transform: translate(10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(10px, 0%);
            opacity: 0;
        }
    }
    @-webkit-keyframes shift {
        0% {
            transform: translate(10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(10px, 0%);
            opacity: 0;
        }
    }
    @-o-keyframes shift {
        0% {
            transform: translate(10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(10px, 0%);
            opacity: 0;
        }
    }
    @keyframes shift {
        0% {
            transform: translate(10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(10px, 0%);
            opacity: 0;
        }
    }
    @-moz-keyframes shift-2 {
        0% {
            transform: translate(0, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(0, 0);
            opacity: 0;
        }
    }
    @-webkit-keyframes shift-2 {
        0% {
            transform: translate(0, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(0, 0);
            opacity: 0;
        }
    }
    @-o-keyframes shift-2 {
        0% {
            transform: translate(0, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(0, 0);
            opacity: 0;
        }
    }
    @keyframes shift-2 {
        0% {
            transform: translate(0, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(0, 0);
            opacity: 0;
        }
    }
    @-moz-keyframes shift-3 {
        0% {
            transform: translate(-10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(-10px, 0);
            opacity: 0;
        }
    }
    @-webkit-keyframes shift-3 {
        0% {
            transform: translate(-10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(-10px, 0);
            opacity: 0;
        }
    }
    @-o-keyframes shift-3 {
        0% {
            transform: translate(-10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(-10px, 0);
            opacity: 0;
        }
    }
    @keyframes shift-3 {
        0% {
            transform: translate(-10px, 155%);
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            transform: translate(-10px, 0);
            opacity: 0;
        }
    }
    .straightRight{
        margin-right: -30px;
        margin-left: 30px;
    }
    .direction-ltr {
        direction: ltr !important;
    }
    .direction-rtl {
        direction: rtl !important;
    }
</style>
